import { DocumentFile, ProjectType, TradeType } from '@shared/models';

export enum ProjectSetupStep {
  SummarizingFiles = 0,
  Completed = 1,
  Failed = 2,
}

export interface SetupProgress {
  projectId: string;
  currentStep: ProjectSetupStep;
  overallPercentage: number;
}

export interface AutomaticProjectSetup {
  name: string;
  tradeType: TradeType;
  projectType: ProjectType;
  files: DocumentFile[];
}
